const exported = {
    differenceInDays(endDate: Date, now: Date): number {
        const diff: number = differenceInMilliseconds(endDate, now);
        return Math.floor(diff / 86400000);
    },

    differenceInMilliseconds(endDate: Date, now: Date) {
        return endDate.getTime() - now.getTime();
    }
};

export default exported;

export const { differenceInDays, differenceInMilliseconds } = exported;
